const createAdminRouter = (prefix: string, routerName: string, key: string = 'id') => {
  return {
    name: prefix + routerName + '/',

    list: '/' + prefix + routerName + '/list',

    add: '/' + prefix + routerName + '/add',

    edit: '/' + prefix + routerName + '/edit/:' + key,

    detail: '/' + prefix + routerName + '/detail/:' + key,

    show: '/' + prefix + routerName + '/:' + key + '/show',
  }
}

export default {
  customer: {
    ...createAdminRouter('admin/', 'customers', 'id'),
  },

  order: {
    ...createAdminRouter('admin/', 'orders', 'id'),
  },

  shipment: {
    ...createAdminRouter('admin/', 'shipments', 'id'),
  },

  user: {
    ...createAdminRouter('admin/', 'users', 'id'),
  },

  container: {
    ...createAdminRouter('admin/', 'containers', 'id'),
  },

  nhomHang: {
    ...createAdminRouter('admin/', 'nhom-hang', 'id'),

    tree: '/admin/nhom-hang/tree',
  },

  product: {
    ...createAdminRouter('admin/', 'products', 'id'),
  },

  nhaCungCap: {
    ...createAdminRouter('admin/', 'nha-cung-cap', 'id'),
  },

  bangGia: {
    ...createAdminRouter('admin/', 'bang-gia', 'id'),
    setup: '/admin/bang-gia/setup',
  },

  bangGiaHangHoa: {
    ...createAdminRouter('admin/', 'bang-gia-hang-hoa', 'id'),
  },

  doiTacGiaoHang: {
    ...createAdminRouter('admin/', 'doi-tac-giao-hang', 'id'),
  },

  donHangOnline: {
    ...createAdminRouter('admin/ban-online/', 'don-hang', 'id'),
  },

  hangHoaLienKet: {
    ...createAdminRouter('admin/ban-online/', 'hang-hoa-lien-ket', 'id'),
  },

  doiSoatOnline: {
    ...createAdminRouter('admin/ban-online/', 'doi-soat', 'id'),
  },

  gianHangOnline: {
    ...createAdminRouter('admin/ban-online/', 'ket-noi-san', 'id'),
  },

  /** Thiết lập kênh bán online (theo gian hàng) */
  thietLapKenhOnline: '/admin/ban-online/thiet-lap-kenh',

  nhomKhachHang: {
    ...createAdminRouter('admin/', 'nhom-khach-hang', 'id'),
  },

  khachHang: {
    ...createAdminRouter('admin/', 'khach-hang', 'id'),
  },

  phieuNhapKho: {
    ...createAdminRouter('admin/', 'phieu-nhap-kho', 'id'),
  },

  phieuXuatKho: {
    ...createAdminRouter('admin/', 'phieu-xuat-kho', 'id'),
  },

  datHang: {
    ...createAdminRouter('admin/', 'dat-hang', 'id'),
    chiTietHang: '/admin/dat-hang-chi-tiet-hang/list',
  },

  hoaDon: {
    ...createAdminRouter('admin/', 'hoa-don', 'id'),
    chiTietHang: '/admin/hoa-don-chi-tiet-hang/list',
  },

  datHangNcc: {
    ...createAdminRouter('admin/', 'dat-hang-ncc', 'id'),
  },

  phieuNhanHang: {
    ...createAdminRouter('admin/', 'phieu-nhan-hang', 'id'),
  },

  traHang: {
    ...createAdminRouter('admin/', 'tra-hang', 'id'),
  },

  yeuCauSuaChua: {
    ...createAdminRouter('admin/', 'yeu-cau-sua-chua', 'id'),
    /** Danh sách theo dòng thiết bị (tab "Chi tiết"). */
    chiTiet: '/admin/yeu-cau-sua-chua/chi-tiet',
    /** Tab "Báo cáo". */
    baoCao: '/admin/yeu-cau-sua-chua/bao-cao',
  },

  kiemKe: {
    ...createAdminRouter('admin/', 'kiem-ke', 'id'),
  },

  danhMucThuKhac: {
    ...createAdminRouter('admin/', 'danh-muc-thu-khac', 'id'),
  },

  donViTinh: {
    ...createAdminRouter('admin/', 'don-vi-tinh', 'id'),
  },

  thuongHieu: {
    ...createAdminRouter('admin/', 'thuong-hieu', 'id'),
  },

  phanLoaiSanPham: {
    ...createAdminRouter('admin/', 'phan-loai-san-pham', 'id'),
  },

  thongTinVatHangHoa: {
    ...createAdminRouter('admin/', 'thong-tin-vat-hang-hoa', 'id'),
  },

  thuocTinh: {
    ...createAdminRouter('admin/', 'thuoc-tinh', 'id'),
  },

  viTri: {
    ...createAdminRouter('admin/', 'vi-tri', 'id'),
  },

  diaChiLayHang: {
    ...createAdminRouter('admin/', 'dia-chi-lay-hang', 'id'),
  },

  congNo: {
    /** Công nợ khách hàng */
    list: '/admin/cong-no-khach-hang/list',
    khachHang: '/admin/cong-no-khach-hang/list',
    theoDon: '/admin/cong-no-theo-don/list',
    theoDonChiTiet: '/admin/cong-no-theo-don-chi-tiet/list',
    thanhToan: '/admin/cong-no-thanh-toan/list',
    /** List GD loại HOAN_TIEN (chi quỹ) */
    hoanTien: '/admin/cong-no-hoan-tien/list',
    detail: '/admin/cong-no-khach-hang/detail/:khachHangId',
    /** Deep-link cũ */
    legacyList: '/admin/cong-no/list',
  },

  chuyenHang: {
    ...createAdminRouter('admin/', 'chuyen-hang', 'id'),
  },

  /**
   * Module Sổ Quỹ (Story 1.7+) — top-level paths (KHÔNG /admin/ prefix per UX-DR).
   * Mỗi route đăng ký qua `generateRoutes` (router/index.tsx) với permission gate.
   * List path exact, detail path defer sang Story 1.10 (FE form/detail).
   */
  soQuy: {
    phieuThu: '/so-quy/phieu-thu',
    phieuThuDetail: '/so-quy/phieu-thu/:id',
    phieuChi: '/so-quy/phieu-chi',
    phieuChiDetail: '/so-quy/phieu-chi/:id',
    baoCao: '/so-quy/bao-cao',
    taiKhoanQuy: '/so-quy/tai-khoan-quy',
    loaiThuChi: '/so-quy/loai-thu-chi',
    // Story 3.3 — Trang hợp nhất sổ quỹ (FR-10). 1.7 defer register → 3.3 thêm.
    // Path `so-quy` (last segment trùng `baoCao`/`taiKhoanQuy`) — SSO pathKey
    // = `so-quy` (BE 3.1 §3.7 Option X NO collision với PhieuThu/Chi pathKey).
    soQuy: '/so-quy/so-quy',
  },

  audit: {
    ...createAdminRouter('admin/', 'audit', 'id'),
  },

  logLoiHeThong: {
    ...createAdminRouter('admin/', 'log-loi-he-thong', 'id'),
  },

  mauIn: {
    hoaDon: '/admin/mau-in/hoa-don',
    settings: '/settings/mau-in',
  },

  /**
   * Module YCX (Yêu cầu xuất hóa đơn) — custom paths KHÔNG createAdminRouter.
   * Lệch pattern CRUD danh mục: list = trang tổng hợp mọi trạng thái + sidebar
   * filter (gộp queue-kt + queue-nvbh cũ); detail = full-page; create = picker → form.
   */
  /** Phiếu xuất kho loại XUAT_HUY — list + tạo/sửa bằng modal (API: phieu-nhap-xuat-kho) */
  xuatHuy: {
    list: '/admin/xuat-huy/danh-sach',
  },

  /** Phiếu xuất kho loại XUAT_TRA_NCC — list + tạo/sửa bằng modal (API: phieu-nhap-xuat-kho) */
  xuatTraNcc: {
    list: '/admin/xuat-tra-ncc/danh-sach',
  },

  yeuCauXuatHoaDon: {
    list: '/admin/yeu-cau-xuat-hoa-don/danh-sach',
    detail: '/admin/yeu-cau-xuat-hoa-don/chi-tiet/:id',
    create: '/admin/yeu-cau-xuat-hoa-don/tao/:hoaDonId',
  },

  /** Thông tin giao hàng — list; add/edit dùng modal trên list (API: dia-chi-nhan-hang) */
  diaChiNhanHang: {
    /** List tất cả KH + filter — menu chính */
    all: '/admin/thong-tin-giao-hang/list',
    /** List scoped theo 1 KH (deep-link từ row KH) */
    list: '/admin/khach-hang/:khachHangId/thong-tin-giao-hang/list',
  },

  /** Thông tin xuất hóa đơn — list; add/edit dùng modal trên list */
  thongTinXuatHoaDon: {
    /** List tất cả KH + filter — menu chính */
    all: '/admin/thong-tin-xuat-hoa-don/list',
    /** List scoped theo 1 KH (deep-link từ row KH / form KH) */
    list: '/admin/khach-hang/:khachHangId/thong-tin-xuat-hoa-don/list',
  },

  /** Module Vận hành. Đơn vị route: /kho/<buoc>/list */
  vanHanh: {
    /** Màn 1 + 2 — Tất cả đơn hàng vận hành (tab "Gán nhân viên" nằm trong trang này) */
    list: '/kho/don-hang/list',
    /** Màn 8 — Chi tiết đơn vận hành (timeline + 5 bước + ảnh + in phiếu) */
    detail: '/kho/don-hang/detail/:id',
    /** Màn 3 — Xếp nhặt */
    xepNhat: '/kho/xep-nhat/list',
    /** Màn 4 — Kiểm tra */
    kiemTra: '/kho/kiem-tra/list',
    /** Màn 5 — Đóng gói */
    dongGoi: '/kho/dong-goi/list',
    /** Màn 6 — Điều phối */
    dieuPhoi: '/kho/dieu-phoi/list',
    /** Màn 7 — Giao hàng */
    giaoHang: '/kho/giao-hang/list',
    /** Bản đồ đơn cần giao theo hạn giao (module lộ trình) */
    banDoGiaoHang: '/kho/ban-do-giao-hang',
  },

  /** 2 màn báo cáo kho port từ `/admin/report/*` của kho-frontend (y hệt path kho). */
  baoCaoKho: {
    /** Báo cáo chi tiết đơn hàng — 1 dòng / dòng hàng hóa (kho ReportList). */
    list: '/admin/report/list',
    /** Báo cáo theo đơn (workflow) — 1 dòng / đơn (kho ReportOrderList). */
    orderList: '/admin/report/don-hang',
  },

  /** Màn 9 — Trung tâm thông báo (module notification P3, pathKey /thong-bao). */
  thongBaoTrungTam: '/thong-bao',

  chat: '/admin/chat',

  dashboard: '/dashboard',

  banHang: '/admin/ban-hang',

  baoCao: {
    root: '/bao-cao',
    tongHop: '/bao-cao/tong-hop',
    doanhThuLn: '/bao-cao/doanh-thu-ln',
    doanhThuLnPivot: '/bao-cao/doanh-thu-ln/pivot',
    tonKho: '/bao-cao/ton-kho',
    tonKhoPivot: '/bao-cao/ton-kho/pivot',
    topSale: '/bao-cao/top-sale',
    topMua: '/bao-cao/top-mua',
    daLuu: '/bao-cao/da-luu',
  },

  /** Trang demo toàn bộ base UI (form, bảng, nút, chip…). */
  uiKit: '/admin/ui-kit',

  settings: '/settings',

  /** Mẫu in PDF/Excel — cài đặt mới. */
  settingsMauIn: '/settings/mau-in',

  /** Cài đặt nhận thông báo của chính user (không cần quyền WEB_BH_SETTINGS_LIST). */
  settingsThongBao: '/settings/thong-bao',

  account: '/account',

  public: {
    containerShipments: '/public/container/shipments',
    developerContact: '/developer/contact',
    privacyPolicy: '/developer/privacy-policy',
  },
}

/** Route không cần đăng nhập. */
export const PUBLIC_PATHS: readonly string[] = [
  '/login',
  '/public/container/shipments',
  '/developer/contact',
  '/developer/privacy-policy',
  ...(process.env.NODE_ENV === 'development' ? ['/offline/mau-in'] : []),
]
